export const useNewTabPageHead = () => {
  useHead({
    title: 'New Tab',
  })
}
